import React from "react";
import useTheme from "hooks/observer";
import "./planExpiredMarquee.scss";

const PLAN_EXPIRED_MESSAGE =
  "Your plan expired. You can still view and read files, but write actions are disabled until renewal.";

function PlanExpiredMarquee() {
  const theme = useTheme();

  return (
    <div
      className={`PlanExpiredMarquee ${theme === "light" ? "PlanExpiredMarquee--light" : "PlanExpiredMarquee--dark"}`}
      role="status"
      aria-live="polite"
    >
      <div className="PlanExpiredMarqueeViewport">
        <span className="PlanExpiredMarqueeText">{PLAN_EXPIRED_MESSAGE}</span>
      </div>
    </div>
  );
}

export default PlanExpiredMarquee;
